module.exports = __webpack_public_path__ + "static/media/headphones.a539e27b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/headphones.png
// module id = 8
// module chunks = 0